export type FrameCb = (now: number, dt: number) => void;

/** Target frame time for a 60fps cap (ms). */
const FRAME_MS = 1000 / 60;

export class GameLoop {
  private running = false;
  private raf = 0;
  private last = 0;
  private acc = 0;
  private cb: FrameCb;

  constructor(cb: FrameCb) {
    this.cb = cb;
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    this.acc = 0;
    const tick = (now: number) => {
      if (!this.running) return;
      const elapsed = now - this.last;
      this.last = now;
      this.acc += elapsed;

      // Cap at ~60fps: skip work on high-refresh displays until a frame is due.
      if (this.acc >= FRAME_MS) {
        const dt = Math.min(this.acc, FRAME_MS * 2);
        this.acc %= FRAME_MS;
        this.cb(now, dt);
      }

      this.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.raf);
  }
}
